import { render, staticRenderFns } from "./LeaveToPayrollPostingSetupEdit.vue?vue&type=template&id=633f1508"
import script from "./LeaveToPayrollPostingSetupEdit.vue?vue&type=script&lang=js"
export * from "./LeaveToPayrollPostingSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports